import { Dayjs } from 'dayjs';

import { ObrigacaoID } from './obrigacao';

export interface IArquivoEditavel {
  processamentoSpedID: number;
  obrigacaoID: ObrigacaoID;
  competencia: Dayjs;
  dataProcessamento: Dayjs;
  tipoArquivo: string;
  etapaParalisacao: string;
  empresaClienteNumeroRegistro: string;
  empresaClienteNomeEmpresarial: string;
  podeEditar: boolean;
  gerandoArquivoEditado: boolean;
  podeReprocessar: boolean;
}

export const Status = {
  EdicaoDisponivel: 'EdicaoDisponivel',
  EdicaoFinalizada: 'EdicaoFinalizada',
  Falha: 'Falha',
};

export const StatusEditavel = [
  Status.EdicaoDisponivel,
  Status.EdicaoFinalizada,
];
